import React from "react";
import Input from "../FormComponents/Input";
import FieldSelectorFromPopup from "../BuilderComponents/FieldSelectorFromPopup";
import Label from "../FormComponents/Label";

const EditMapElement = ({ setEditElementData, editElementData, tableId, tableType }) => {
  const handleWidthChange = (e) => {
    const value = parseInt(e.target.value, 10) || 0;
    setEditElementData((prev) => ({ ...prev, card_width: value }));
  };
  const handleChangeLocation = (location) => {
    setEditElementData((prev) => ({ ...prev, location_point: location.id }));
  };
  return (
    <div className="builder_form">
      <Input label="Card Width" type="number" value={editElementData.card_width || ""} onChange={handleWidthChange} />
      <Label>Location Field</Label>
      <FieldSelectorFromPopup
        tableId={tableId}
        tableType={tableType}
        fieldId={editElementData.location_point || ""}
        onSelect={handleChangeLocation}
      />
    </div>
  );
};

export default EditMapElement;
